import React, { Component } from "react";
import "../Styles/Footer.css";
// Images
import DollarIcon from "../img/Icons/dollar_icon.png";

export default class Footer extends Component {
  render() {
    return (
      <div className="Footer animate__animated animate__slideInLeft">
        <p>© 2021 By FilexGH</p>
      </div>
    );
  }
}
